import { omniAtom } from "src/utils/atoms";

export const pageAtom = omniAtom({
	key: "page",
	value: null as string | null,
});
